import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';
import {twMerge} from 'tailwind-merge';

import {useGoToBaseUrl} from '../../Panel/hooks/hooks';
import {useViewBarContext} from '../NamedWorkspaceViewBarContext';
import {type NamedWorkspaceMenuItem} from '../types';
import {
  NamedWorkspaceMenuItemComp,
  type NamedWorkspaceMenuItemProps,
} from './NamedWorkspaceMenuItem';

type NamedWorkspaceMenuGroupProps = {
  options: NamedWorkspaceMenuItem[];
  defaultMaxItems: number;
  testId?: string;
  menuItemComponent?: React.ComponentType<NamedWorkspaceMenuItemProps>;
  showLegacyCurrentViewCheckmark?: boolean;
};

export const NamedWorkspaceMenuGroup = ({
  options,
  defaultMaxItems,
  testId,
  menuItemComponent: MenuItemComponent = NamedWorkspaceMenuItemComp,
  showLegacyCurrentViewCheckmark = false,
}: NamedWorkspaceMenuGroupProps) => {
  const {currentWorkspaceViewRef, onMenuItemClick} = useViewBarContext();
  const [shouldShowAll, setShouldShowAll] = useState(false);

  const dropdownItems =
    !shouldShowAll && options.length > defaultMaxItems
      ? options.slice(0, defaultMaxItems)
      : options;
  const goToBaseURL = useGoToBaseUrl();

  return (
    <>
      <DropdownMenu.Group>
        {dropdownItems.map(option => {
          return (
            <DropdownMenu.CheckboxItem
              key={
                option.viewCid + option.namedWorkspaceId.id + option.optionType
              }
              id={option.namedWorkspaceId.id}
              className={twMerge(
                'items-start text-wb-text-primary dark:text-moon-300',
                !showLegacyCurrentViewCheckmark &&
                  'radix-state-checked:bg-wb-surface-option-selected radix-state-checked:rounded-s'
              )}
              checked={currentWorkspaceViewRef.id === option.viewCid}
              data-test={testId}
              data-perf-action="workspace-switch"
              onClick={() => {
                onMenuItemClick(option.viewCid, option.namedWorkspaceId);
                goToBaseURL();
              }}>
              <MenuItemComponent option={option} />
              {showLegacyCurrentViewCheckmark && (
                <DropdownMenu.ItemIndicator>
                  <Icon name="checkmark" width={18} height={18} />
                </DropdownMenu.ItemIndicator>
              )}
            </DropdownMenu.CheckboxItem>
          );
        })}
      </DropdownMenu.Group>
      {options.length > defaultMaxItems && (
        <p
          className={twMerge(
            'my-6 ml-[3rem] cursor-pointer text-base font-semibold leading-[24px]',
            'text-wb-text-link hover:text-wb-text-link-hover'
          )}
          onClick={() => setShouldShowAll(prev => !prev)}>
          {shouldShowAll ? 'Show less' : 'Show all'}
        </p>
      )}
    </>
  );
};
